import {role_rights} from '../.js'
<template>
  <div>

    <div class="row">
      <div class="col-sm-12">
        <div v-if="message.success!=''" class="alert alert-success">
         <i class="fa fa-check fa-icons"></i> {{message.success}}
        </div>
      </div>
    </div>

    <div class="animated fadeIn">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-header">
              <div>
                <span class="title_head">Unit List Table<p v-show="hide">{{ unit_view }}</p></span>
                <span v-if="unit_rights === true"><button type="button" class="btn btn-sm btn-primary label_bttn" unit="secondary" @click="openmodel()"><i class="fa fa-plus"></i> Add Unit</button></span>
              </div>
            </div>
            <div class="card-body">
              <div class="table-responsive-sm">
                <vue-good-table 
                :columns="columns" 
                :rows="rows" 
                 mode="remote"
                 ref="my-table"
                 @on-page-change="onPageChange"
                 @on-sort-change="onSortChange"
                 @on-column-filter="onColumnFilter"
                 @on-per-page-change="onPerPageChange"
                 :totalRows="totalRecords"
                 :pagination-options="{
                    enabled: true,
                    perPage: 5,
                                }"
                styleClass="vgt-table striped bordered table-sm condensed" :lineNumbers="true">
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'action'">
                      <span v-if="unit_rights === true">
                        <span v-if="props.row.company_id != 'I2OCGLB'">
                          <i class="fa fa-edit" @click.prevent="editunit(props.row)"></i>
                          <i class="fa fa-trash" @click.prevent="deleteunit(props.row)"></i>                        
                        </span>
                        <span v-else>
                          <span v-if="is_admin === true">
                            <i class="fa fa-edit" @click.prevent="editunit(props.row)"></i>
                            <i class="fa fa-trash" @click.prevent="deleteunit(props.row)"></i>
                          </span>
                          <span v-else>
                            <i class="fa fa-edit" style="color:grey !important;"></i>
                            <i class="fa fa-trash" style="color:grey !important;"></i>
                          </span>
                        </span>
                      </span>
                      <span v-else>
                        <i class="fa fa-edit" style="color:grey !important;"></i>
                        <i class="fa fa-trash" style="color:grey !important;"></i>
                      </span>
                    </span>
                    <span v-else>
                      {{props.formattedRow[props.column.field]}}
                    </span>
                  </template>
                  <div slot="emptystate" style="text-align:center;" v-if="loading">
                    <i class="fa fa-spinner fa-spin"></i>&nbsp;Loading
                  </div>
                </vue-good-table>
                

                <b-modal title="Add Unit" no-close-on-esc no-close-on-backdrop class="modal-info" hide-footer v-model="largeModal" @ok="largeModal = false">
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="form-group" >
                        <label for="name">Unit Name :<span class="star">*</span></label>
                        <b-form-input ref="txtunitname" :class="{'is-invalid' :message.unit_name1}" type="text" class="form-control" v-model="unit_name1" placeholder="Enter Unit Name" @blur.native="onComplete('uname')"></b-form-input>
                        <small  class="form-text text-muted" v-if="message.unit_name1!=''" >
                          <strong style="color: red;">{{message.unit_name1}}</strong>
                        </small>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group" >
                        <label for="name">Unit Description :</label>
                          <input :class="{'is-invalid' :message.unit_desc1}" type="text" class="form-control" v-model="unit_desc1" placeholder="Enter Unit Description" v-on:keyup="onComplete('udesc')">
                          <small  class="form-text text-muted" v-if="message.unit_desc1!=''"><strong style="color: red;">{{message.unit_desc1}}</strong></small>
                      </div>
                    </div>
                  </div>

                  <div class="card-footer modal_footer">
                    <button type="save" class="btn btn-sm btn-primary" v-if="saveBtn"  @click.prevent="submit()"><i class="fa fa-dot-circle-o"></i> Save</button>
                    <button type="save" class="btn btn-sm btn-primary" v-if="editBtn" @click.prevent="edit()"><i class="fa fa-dot-circle-o"></i> Save</button>
                  </div>
                </b-modal>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Spinner v-if="loading"></Spinner>     
  </div>
</template>

<script>
import Spinner from '../../spinner.vue'
// import {globalStore} from '../../main.js'
export default {
  name: 'unit',
  components: { Spinner },
  
  data(){
    return {
      // localvar:globalStore.globalvar,
      // role_rights:false,
      // pg_view:false,
      // pg_rights:false,
      is_admin: false,
      shpfrst_time:false,
		  ufrst_time:false,
      hide:false,
      largeModal:false,
      largeModal1:false,
      editBtn:false,
      saveBtn:true,
      loading:false,
      unit_name1:'',
      unit_desc1:'',
      unit_name2:'',
      unit_desc2:'',
      unit_id:'',
      submit_true: true,
      totalRecords: 0,
      serverParams: {
       columnFilters: {
                   },
        sort: {},
        page: 1, 
        perPage: 5
      },
      columns: [
      {
        label: 'Unit Name',
        field: 'unit_name',
        width: '30% !important'
      },
      {
        label: 'Unit Description',
        field: 'unit_desc',
        width: '60% !important'
      },
      {
        label: 'Action',
        field: 'action',
        width: '10% !important'
      },
      ],
      rows:[],
      submit_true:0,
      message:{
        success:'',
        unit_name1:'',
        unit_desc1:'',
        unit_name2:'',
        unit_desc2:'',
      }
    };
  },
  computed:{
    unit_view: function(){
        if(this.$store.getters.get_unit_view === true){
            this.shopuser('comp');
            this.getunit('comp');
            this.is_admin = this.$store.getters.get_is_admin
            return true
        }
        else{
          return false
        }
      },
      unit_rights: function(){
        return this.$store.getters.get_unit_rights
      }
  },
  // created(){
  //   var roles = JSON.parse(localStorage.getItem('roles'))
  //     if(roles[24].page_name == 25){
  //       this.pg_view = roles[24].view
  //       this.pg_rights = roles[24].rights
  //       if(this.pg_view){
  //         this.shopuser();
  //         this.getunit();
  //       }
  //     }
  // },

  methods:{
     updateParams(newProps) {
          this.serverParams = Object.assign({}, this.serverParams, newProps);
      },
    
    onPageChange(params) { 
           this.updateParams({page: params.currentPage});
           this.getunit();
    },

    onPerPageChange(params) {
      this.updateParams({perPage: params.currentPerPage,page:1});
      this.getunit();
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        },page:1
      });
      this.getunit();
    },
    
    onColumnFilter(params) {
      this.updateParams(params);
      this.getunit();
    },

    shopuser(val){
      if(val === 'comp'){
          if(this.shpfrst_time === false){
            this.shpfrst_time = true
          }
          else{
            return
          }
        }
      var _this=this
      this.$http.get('/api/shopusers').then(function(response){

      }).catch(function(error){
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null)
          _this.$router.push('/');
        }
        if(error.response.data.error.message === "Cannot read property 'cmpname' of null"){
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null)
          _this.$router.push('/');
        }
      })
    },

    chkExist(){
        var _this = this
        this.unit_name1 = this.unit_name1.trim()
        if(this.unit_name1 != ''){
          this.$http.get('/api/unittypes/chk_exist?filter[where][unit_name]='+this.unit_name1).then(function (response){
            if(response.data.length > 0){
              _this.unit_name1 = ''
              _this.message.unit_name1 = 'Unit name already exist'
              _this.$refs['txtunitname'].focus()
            }
            else{
              _this.message.unit_name1 = false
            }
          })
          .catch(function(error){
            _this.message.unit_name1 = false
          });
        }
        else{
          _this.message.unit_name1 = false
        }
      },

    getunit(val){
      this.loading = true
      if(val === 'comp'){
          if(this.ufrst_time === false){
            this.ufrst_time = true
          }
          else{
            return
          }
        }
      var _this=this;
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      this.$http.get('/api/unittypes?params='+JSON.stringify(filteParam)).then(function(response){
        _this.totalRecords = response.data[0].totalRecords;
        response.data.shift()
        if(response.data != undefined)
        _this.rows=response.data
        _this.loading = false
      }).catch(function(error){
        console.log(error)
        _this.loading = false
      })
    },
    
    deleteunit(data){
      var r = confirm("Are you sure you want to delete?");
      if (r == true) {
        var _this=this
        _this.loading=true;
        this.$http.delete('/api/unittypes/'+data.id).then(function (response) {
          _this.loading=false;
          _this.message.success="Unit Deleted Successfully";
          setTimeout(function(){_this.message.success=false;}, 4000);
          _this.getunit()
        })
        .catch(function (error) {
          _this.loading=false;
          _this.message.success="Something Went Wrong";
          setTimeout(function(){_this.message.success=false;}, 4000);
          console.log(error.response);
        });
      }
    },

    editunit(data){
      this.largeModal = true
      this.saveBtn = false
      this.editBtn = true
      this.message.unit_name1 = ''
      this.message.unit_desc1=''
      this.unit_name1 = data.unit_name
      this.unit_desc1 = data.unit_desc
      this.unit_id = data.unit_id
    },

    edit(){
      var _this = this
      this.submit_true=0;
      this.onComplete('check')
    
      if(this.submit_true==0){
        _this.largeModal = false,
        _this.loading = true;
        var data1 = {
          unit_name:this.unit_name1,
          unit_desc:this.unit_desc1,
        }
        this.$http.post('/api/unittypes/update?where[id]='+_this.unit_id,data1).then(function(response){
          _this.loading=false;
          _this.message.success="Unit Updated SuccessFully";
          setTimeout(function(){_this.message.success=false;}, 4000);
          _this.getunit()
          _this.reset()
        }).catch(function(error){
          console.log(error.response)
          _this.loading=false;
          _this.message.sucess="SomeThing Went Wrong"
        })
      }
    },

    openmodel(){
          
      this.largeModal = true
      this.saveBtn = true
      this.editBtn = false
      var _this = this
      _this.unit_name1 = ''
      _this.unit_desc1 = ''
      _this.message.unit_desc1 = ''
      _this.message.unit_name1 = ''
     },

    onComplete(value){
      // var unameregex=/^[^\s].+[^\s]$/
      var unameregex=/^[A-Za-z]+$/
      var udescregex=/^[-_a-zA-Z0-9.]+$/

      this.message.unit_desc1='';
      if(value === 'uname' || value === 'check'){
        if(this.unit_name1==''){
          this.message.unit_name1 ='Required';
          this.submit_true=1;
        }
        else if(this.unit_name1.length < 1){
          this.message.unit_name1  ='Minimum 1 characters';
          this.submit_true=1;
        }
        else if(this.unit_name1.length > 30){
          this.message.unit_name1 ='Maximum 30 characters';
          this.submit_true=1;
        }
        else if(unameregex.test(this.unit_name1)==false){
          this.message.unit_name1 ='Enter Valid Unit Name';
          this.submit_true=1;
        }else{
          this.chkExist()
          // this.message.unit_name1  ='';
        }
      }

      if(value === ('udesc'|| 'check') && this.unit_desc1!=''){
        if(this.unit_desc1.length > 100){
          this.message.unit_desc1 ='Maximum 100 characters only';
          this.submit_true=1;
        }
        else if(this.unit_desc1.length < 1){
          this.message.unit_desc1  ='Minimum 1 characters only';
          this.submit_true=1;
        }
        else if(udescregex.test(this.unit_desc1)==false){
          this.message.unit_desc1 ='Enter Valid Unit Description';
          this.submit_true=1;
        }
        else{
          this.message.unit_desc1  ='';
        }
      }
    },

    submit(){
      var _this = this
      this.submit_true=0;
      this.onComplete('check')

      if(this.submit_true==0){
        _this.largeModal = false,
        _this.loading = true;
        var data = {
          unit_name:this.unit_name1,
          unit_desc:this.unit_desc1,
        }
     
        this.$http.post('/api/unittypes',data).then(function(response){
          _this.loading=false;
          _this.message.success="Unit Added Successfully";
          setTimeout(function(){ _this.message.success=false;}, 4000);
          _this.getunit()
          _this.reset()
        }).catch(function(error){
          console.log(error.response)
          _this.loading=false;
          _this.message.sucess="SomeThing Went Wrong"
        })
      }
    },
    reset(){
      this.unit_name1=''
      this.unit_desc1=''
      this.unit_name2=''
      this.unit_desc2=''
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/views/setting/unit.vue